import { render, staticRenderFns } from "./ListGrades.vue?vue&type=template&id=0f89d8e6"
import script from "./ListGrades.vue?vue&type=script&lang=js"
export * from "./ListGrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports